<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/member/account' }">账户余额</el-breadcrumb-item>
					<el-breadcrumb-item>充值凭证</el-breadcrumb-item>
				</el-breadcrumb>
				<el-button size="medium" style="position: absolute;top: 5px;right: 10px" type="primary" @click="addAccountShow">添加充值凭证</el-button>
			</div>

			<div v-loading="loading">
				<div class="order-list">
					<nav>
						<li>汇款名称</li>
						<li>开户银行</li>
						<!--<li>银行行号</li>-->
						<li>汇款账号</li>
						<li>汇款金额</li>
						<li>凭证图片</li>
					</nav>

					<div class="list" v-if="orderList.length > 0">
						<div class="item" v-for="(orderItem, orderIndex) in orderList" :key="orderIndex">
							<div class="head">
								<span class="order-no" v-if="orderItem.or_numsn" style="margin-right: 50px;"margin-left: 50px;>编号：{{ orderItem.or_numsn }}</span>
								<span v-if="orderItem.remark" style="color: #ff8143;">备注信息：{{ orderItem.remark }}</span>
								<span style="float: right; color: #4caf50; font-weight: bold;" v-if="orderItem['iftrue'] ==1">已入账</span>
								<span style="float: right;color: #ff8143; font-weight: bold;" v-else-if="orderItem['iftrue'] ==2">待审核</span>
								<span style="float: right;color: #ff547b; font-weight: bold;" v-else>驳回</span>
								<span class="create-time" style="float: right;">{{ $util.timeStampTurnTime(orderItem.create_time) }}</span>
							</div>
							<ul>
								<li><span>{{ orderItem.comname }}</span></li>
								<li><span>{{ orderItem.bankname }}</span></li>
								<!--<li><span>{{ orderItem.bankcode }}</span></li>-->
								<li><span>{{ orderItem.bankid }}</span></li>
								<li><span>￥{{ orderItem.account_data }}</span></li>
								<li>
									<div class="img-wrap"><el-image :src="$img(orderItem.voc_images)" fit="cover" @error="imageError(orderIndex)"></el-image></div>									
								</li>
							</ul>
						</div>
					</div>
					<div v-else-if="!loading && orderList.length == 0" class="empty-wrap">暂无相关订单</div>
				</div>

				<div class="pager">
					<el-pagination 
						background
						:pager-count="5" 
						:total="total" 
						prev-text="上一页" 
						next-text="下一页" 
						:current-page.sync="currentPage" 
						:page-size.sync="pageSize" 
						@size-change="handlePageSizeChange" 
						@current-change="handleCurrentPageChange" 
						hide-on-single-page
					></el-pagination>
				</div>
			</div>
		</el-card>
		
		<!--收货地址添加-->
		<el-dialog title="上传充值凭证" :visible.sync="dialogVisible" width="880px">
			<el-form ref="form" :model="accountForm" :rules="infoRules" label-width="80px" style="overflow: hidden;">
				<div style="width: 400px; float: left;">
					<el-form-item label="名  称：" prop="comname">
						<el-input v-model="accountForm.comname" placeholder="请输入汇款账户名称（公司名称或姓名）"></el-input>
					</el-form-item>	
					<el-form-item label="开户行：" prop="bankname">
						<el-input v-model="accountForm.bankname" maxlength="11" placeholder="请输入汇款账户开户行名称"></el-input>
					</el-form-item>
					<el-form-item label="行  号：" prop="bankcode">
						<el-input v-model="accountForm.bankcode" placeholder="请输入汇款账户开户行行号"></el-input>
					</el-form-item>				
					<el-form-item label="帐  号：" prop="bankid">
						<el-input v-model="accountForm.bankid" placeholder="请输入汇款账户账号"></el-input>
					</el-form-item>
			
					<el-form-item label="金  额：" prop="nummoney">
						<el-input type="number"  v-model="accountForm.nummoney" placeholder="请输入充值金额"></el-input>
					</el-form-item>
					<el-form-item label="备   注：" prop="inv_remark">
						<el-input v-model="accountForm.inv_remark" placeholder="订单备注信息"></el-input>
					</el-form-item>
				</div>
				<div style="width: 400px; float: right;">	
					<div class="preview" style="font-size: 14px;color: #606266;">
						<div class="title">充值凭证<span style="color: red;">（*）</span></div>
						<div class="content">
							完善汇款信息凭证有助于您快速申请通过入账。
						</div>
					</div>
					<el-upload :action="uploadActionUrl" :show-file-list="false" :on-success="handleAvatarSuccess" class="upload">
						<div class="img-wrap" style=" border: 1px solid #dedede; width: 398px; height: 296px;display: flex; justify-content: center;align-items: center;"><img :src="$img(accountForm.voc_images)" @error="accountForm.voc_images = 'public/static/img/file.png'" /></div>
					</el-upload>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="recharge('form')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { info} from '@/api/member/info';
	import { recharge_list, recharge_two } from "@/api/member/account"
	import { mapGetters } from 'vuex';
	import Config from '@/utils/config';

	export default {
		name: "recharge_list",
		components: {},
		data: () => {
			return {
				isSub: false,
				dialogVisible:false,
				orderList: [],
				total: 0,
				currentPage: 1,
				pageSize: 10,
				loading: true,
				yes: true,
				infoRules: {
					comname: [
						{ required: true, message: '请输入汇款账户名称（公司名称或姓名）', trigger: 'blur' },
					],
					bankname: [
						{ required: true, message: '请输入汇款账户开户行名称', trigger: 'blur' },
					],
					bankcode: [
						{ required: true, message: '请输入汇款账户开户行行号', trigger: 'blur' },
					],
					bankid: [
						{ required: true, message: '请输入汇款账户账号', trigger: 'blur' },
					],
					nummoney: [
						{ required: true, message: '请输入充值金额', trigger: 'blur' },
					]
				},
				accountForm: {
					comname:'',
					bankname: "",
					bankcode: "",
					bankid: "",
					nummoney: 100.00,
					inv_remark:"",
					voc_images: "",
				},
				memberInfo: {
					comname: '', //昵称
					codename: '',
					bank_code: '',
					bank_num: '',
				},
				imgUrl: '',
				uploadActionUrl: Config.baseUrl + '/api/upload/voucherimg',
			}
		},
		created() {
			this.getInfo();
			this.getListData()
		},
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
		computed: {
			...mapGetters(['defaultGoodsImage'])
		},
		methods: {
			
			getInfo() {
				info()
				.then(res => {
					console.log('秦霄贤',res.data);
					if (res.code == 0) {
						this.memberInfo.comname = res.data.comname;
						this.memberInfo.codename = res.data.codename;
						this.memberInfo.bank_code = res.data.bank_code;
						this.memberInfo.bank_num = res.data.bank_num;
					}
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
				});
			},
			handlePageSizeChange(size) {
				this.pageSize = size
				this.refresh()
			},
			handleCurrentPageChange(page) {
				this.currentPage = page
				this.refresh()
			},
			refresh() {
				this.loading = true
				this.getListData()
			},
			recharge(formName) {
				if (this.isSub){
					return
				}
				this.$refs[formName].validate(valid => {
					if (valid) {
						
						if(this.accountForm.voc_images=='public/static/img/file.png'){
							this.$message.warning('凭证图片不能为空')
							return
						}
						if(this.accountForm.nummoney<=0){
							this.$message.warning('充值金额有误')
							return
						}
						this.isSub = true
						recharge_two({
							accountForm: this.accountForm
						}).then(res => {
							if (res.data && res.code == 0) {
								this.$message.warning('提交成功')
							} else {
								this.$message.warning(res.message)
							}
							this.isSub = false
							this.dialogVisible = false
						}).catch(err => {
							this.$message.error(err.message)
							this.isSub = false
							this.dialogVisible = false
						})
					}
				})
			},
			//打开添加收货地址弹出层
			addAccountShow() {
				this.dialogVisible = true
				this.accountForm.comname = this.memberInfo.comname
				this.accountForm.bankname = this.memberInfo.codename
				this.accountForm.bankcode =  this.memberInfo.bank_num
				this.accountForm.bankid =this.memberInfo.bank_code
				this.accountForm.nummoney = 100.00
				this.accountForm.voc_images = ''
				this.accountForm.inv_remark = ""
			},
			handleAvatarSuccess(res, file) {
				this.imgUrl = res.data.pic_path;
				this.accountForm.voc_images = this.imgUrl;
			},
			getListData() {
				recharge_list({
					page: this.currentPage,
					page_size: this.pageSize
				}).then(res => {
					if (res.code == 0 && res.data) {
						this.orderList = res.data.list;
					} else {
						this.$message.warning(res.message)
					}
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			imageError(index) {
				this.orderList[index].cover_img = this.defaultGoodsImage;
			},
			handleDetail(index, row) {
				this.$router.push({path: '/member/recharge_detail', query: {}})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		position: relative;
	}
	
	.null-page {
		width: 100%;
		height: 730px;
		background-color: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	
	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
		box-shadow: unset;
	}

	.el-card {
		border: 0;
	}

	.order-list {
		nav {
			overflow: hidden;
			padding: 10px;
			background: #fff;
			margin-bottom: 10px;
			border-bottom: 1px solid #eeeeee;

			li {
				float: left;

				&:nth-child(1) {
					width: 18%;
				}

				&:nth-child(2) {
					width: 18%;
				}

				/*&:nth-child(3) {
					width: 16%;
				}*/

				&:nth-child(3) {
					width: 18%;
				}

				&:nth-child(4) {
					width: 18%;
				}
				&:nth-child(5) {
					width: 28%;
				}
			}
		}

		.list {
			.item {
				margin-bottom: 20px;
				border: 1px solid #eeeeee;
				border-top: 0;

				.head {
					padding: 8px 10px;
					background: #f7f7f7;
					font-size: 12px;
					overflow: hidden;

					.create-time {
						margin-right: 10px;
					}

					border-bottom: 1px solid #eeeeee;

					a {
						margin: 0 10px 0 20px;
					}

					.order-type {
						margin-left: 30px;
					}
				}
			}

			ul {
				background-color: #fff;
				padding: 10px;
				overflow: hidden;

				li {
					float: left;
					line-height: 60px;

					&:nth-child(1) {
						width: 18%;
					}

					&:nth-child(2) {
						width: 18%;
					}

					/*&:nth-child(3) {
						width: 16%;
					}*/

					&:nth-child(3) {
						width: 18%;
					}
					&:nth-child(4) {
						width: 18%;
					}
					&:nth-child(5) {
						width: 28%;
						line-height: inherit;

						.img-wrap {
							height: 60px;
							float: left;
							margin-right: 10px;
							border-radius: 5px;
							overflow: hidden;
							
							.el-image {
								width: 100%;
								height: 100%;
							}
						}

						.info-wrap {
							margin-left: 70px;

							h5 {
								font-weight: normal;
								font-size: $ns-font-size-base;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								overflow: hidden;
								margin-right: 10px;
							}
						}
					}

				}
			}
		}

		.empty-wrap {
			text-align: center;
			padding: 10px;
		}
	}
</style>
